module.exports = __webpack_public_path__ + "static/media/icon-circle-tick.896c9e32.svg";